var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":10}},[_c('a-col',{attrs:{"span":12}},[_c('inspect-content')],1),_c('a-col',{attrs:{"span":12}},[_c('inspect-project')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }